/**
 * Stock summary route — mounts `<StockSummaryPage />`.
 *
 * @see apps/web/src/features/inventory/stock/stock-summary-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { StockSummaryPage } from "../../../../features/inventory/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/stock/")({
  component: StockIndexRoute,
});

function StockIndexRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Inventory", to: "/" }, { label: "Stock" }]}
      viewportClassName="p-0"
      contentClassName="max-w-none"
    >
      <StockSummaryPage />
    </WorkspaceShell>
  );
}
